import styled from "styled-components";

export const MarketingCarouselCategoriesWrapper = styled.div`
`;

export const MarketingCarouselCategoriesContainer = styled.div`
    max-width: 1200px;
    margin: 0 auto;
    width: 100%;

    .swiper {
        padding: 30px 0;
    }

    .swiper-wrapper{
        transition-timing-function:linear;
    }

    .swiper-slide {
        display: inline-block;
        width: auto;
        min-width: 100px;
    }
`;

export const MarketingCarouselCategorieCard = styled.div<{ active?: boolean }>`
    padding: 8px 12px;
    border: 1px solid ${({ theme }) => theme ? theme.v3.colors.grey88 : null};
    border-radius: 10px;
    max-width: 328px;
    height: 100%;
    text-align: center;

    &:hover {
        cursor: pointer;
        box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.2);
    }
`;